import { render } from "./WebBrowserPropsCmp.vue?vue&type=template&id=6222cb2b"
import script from "./WebBrowserPropsCmp.vue?vue&type=script&lang=js"
export * from "./WebBrowserPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__